<template>
  <el-card class="h-full relative" :body-style="{ height: '100%' }">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="文字" name="1" class="h-full"> </el-tab-pane>
      <el-tab-pane label="图片" name="2" class="h-full"> </el-tab-pane>
      <el-tab-pane label="视频" name="3" class="h-full"> </el-tab-pane>
    </el-tabs>
    <div>
      <el-input
        v-model.trim="searchData.name"
        size="small"
        placeholder="素材名称"
        class="w-180px mr-10px"
        clearable
      ></el-input>
      <el-input
        v-model.trim="searchData.personnel"
        size="small"
        placeholder="上传人"
        class="w-180px mr-10px"
        clearable
      ></el-input>
      <el-select
        v-model="searchData.deptment"
        placeholder="部门"
        ref="treeSelectRef"
        class="mr-10px"
        clearable
        popper-class="data-source-select-tree"
      >
        <el-option :value="treeData" :style="{ padding: 0, height: '100%', fontWeight: 'normal' }">
          <el-tree
            class="text-white max-h-274px overflow-x-hidden data-source-tree"
            :data="treeData"
            :props="defaultProps"
            @node-click="treeNodeClick"
            :check-on-click-node="true"
          >
          </el-tree>
        </el-option>
      </el-select>
      <el-select
        v-model="searchData.status"
        class="mr-10px w-180px"
        clearable
        placeholder="发布状态"
      >
        <el-option label="已发布" :value="1"></el-option>
        <el-option label="未发布" :value="0"></el-option>
      </el-select>
      <el-date-picker
        v-model="searchData.timeRange"
        value-format="yyyy-MM-dd HH:mm:ss"
        type="datetimerange"
        start-placeholder="上传时间"
        end-placeholder="上传时间"
        range-separator="至"
        size="small"
        class="mr-10px"
      >
      </el-date-picker>
      <el-button type="primary" size="small" @click="searchList">搜索</el-button>
      <el-button type="primary" size="small" @click="reset">重置</el-button>
      <el-button
        type="primary"
        size="small"
        @click="operateBtn({}, 'create')"
      >
        新增
      </el-button>
      <el-button
        type="danger"
        size="small"
        @click="deleteData(selectionList)"
      >
        删除
      </el-button>
    </div>
    <el-table
      :data="tableData"
      width="100%"
      class="mt-20px"
      height="calc(100% - 159px)"
      border
      stripe
      @selection-change="selectionChange"
      v-loading="tableLoading"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <el-table-column show-overflow-tooltip label="素材名称" prop="name"></el-table-column>
      <el-table-column show-overflow-tooltip label="上传人" prop="uploaderName"></el-table-column>
      <el-table-column show-overflow-tooltip label="部门" prop="deptName"></el-table-column>
      <el-table-column show-overflow-tooltip label="发布状态" prop="status">
        <template slot-scope="scope">
          {{ scope.row.status === 1 ? '已发布' : scope.row.status === 0 ? '未发布' : '' }}
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="上传时间" prop="uploadTime">
        <template slot-scope="scope">
          {{
            scope.row.uploadTime ? dayjs(scope.row.uploadTime).format('YYYY-MM-DD HH:mm:ss') : ''
          }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="left" width="300px">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="operateBtn(scope.row, 'read')"
          >
            查看
          </el-button>
          <el-button
            size="mini"
            @click="operateBtn(scope.row, 'update')"
          >
            编辑
          </el-button>
          <el-button size="mini" @click="deleteData([scope.row])">
            删除
          </el-button>
          <el-button
            size="mini"
            @click="toPublish(scope.row)"
          >
            前往发布
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="flex justify-end mt-20px">
      <el-pagination
        background
        @size-change="getList"
        @current-change="getList"
        :current-page.sync="page.pageNo"
        layout="total, sizes, prev, pager, next, jumper"
        :page-size.sync="page.pageSize"
        :total="page.total"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :pager-count="5"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="发布栏目"
      class="mini-dialog"
      :visible.sync="dialogVisible"
      v-dialogDrag
      :close-on-click-modal="false"
      @close="dialogVisible = false"
    >
      <el-form
        class="h-full"
        :model="formData"
        :rules="formRules"
        ref="formRef"
        label-width="150px"
        v-if="dialogVisible"
      >
        <el-form-item label="发布栏目" prop="content">
          <el-select
            v-model="formData.content"
            value-key="id"
            clearable
            filterable
            placeholder="发布栏目"
            @change="colunmChange"
          >
            <el-option
              v-for="(it, index) in colunmList"
              :key="index"
              :label="it.name"
              :value="it"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="text-center">
        <el-button type="primary" size="small" @click="save"> 下一步 </el-button>
        <el-button size="small" @click="cancel">取消</el-button>
      </div>
    </el-dialog>
    <AddEditDialog
      class="absolute top-0 left-0 z-100 h-full w-full"
      v-if="showAddEditDialog"
      :operateType="operateType"
      :title="operateTitle"
      :tabType="activeName"
      :userInfo="userInfo"
      :detailData="detailData"
      @close="closeAddEditDialog"
      @success="getList"
    ></AddEditDialog>
    <PublishAddEdit
      class="absolute top-0 left-0 z-100 h-full w-full"
      v-if="openPublish"
      @close="openPublish = false"
      @on-success="handleSaveSuccess"
      :detailData="publishDetailData"
      :columnId="columnId"
      :operationType="'materialPublish'"
    ></PublishAddEdit>
  </el-card>
</template>

<script>
import { OrganizationApi } from '@wiz-api/abp-identity'
import { MaterialApi, ColumApi, ColumnRightsApi } from '@wiz-api/workbench'
import { EafProfileApi } from '@wiz-api/account'

const eafProfileApi = new EafProfileApi()
const organizationApi = new OrganizationApi()
const materialApi = new MaterialApi()
const columnRightsApi = new ColumnRightsApi()
const columApi = new ColumApi()
const AddEditDialog = () => {
  return import('./AddEditDialog')
}
const PublishAddEdit = () => {
  return import('../ColumnPublishManagement/Detail')
}
export default {
  components: { AddEditDialog, PublishAddEdit },
  data() {
    return {
      activeName: '1',
      searchData: {
        name: '',
        personnel: '',
        deptment: '',
        departmentId: '',
        timeRange: '',
        status: '',
      },
      tableData: [],
      deptmentList: [],
      treeData: [],
      columTreeData: [],
      selectionList: [],
      page: { pageNo: 1, pageSize: 15, total: 0 },
      defaultProps: { children: 'children', label: 'displayName' },
      tableLoading: false,
      showAddEditDialog: false,
      operateType: false,
      openPublish: false,
      dialogVisible: false,
      operateTitle: '',
      detailData: {},
      formData: { content: '' },
      formRules: { content: [{ required: true, message: '请输选择栏目', trigger: 'change' }] },
      colunmList: [],
      searchDataList: [],
      publishDetailData: {},
      currentPublishData: {},
      columnPermission: [],
      userInfo: {},
    }
  },
  watch: {
    'searchData.deptment': {
      handler(val) {
        if (!val) {
          this.searchData.departmentId = ''
          this.searchData.deptment = ''
        }
      },
    },
  },
  computed: {
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
  },
  methods: {
    save() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          const isPermissions = this.columnPermission.includes('add')
          if (!isPermissions) {
            this.$message.warning('当前栏目没有发布权限')
            return
          }
          this.columnId = this.formData.content.id
          this.cancel()
          this.openPublish = true
          const params = {
            externalLink: '',
            isShow: false,
            isTop: false,
            summary: '',
            title: this.currentPublishData.name,
            columnId: this.formData.content.id,
          }
          switch (this.activeName) {
            case '1':
              this.publishDetailData = {
                attachFile: '',
                columnName: this.formData.content.name,
                content: this.currentPublishData.content,
                textAuthor: this.userInfo.id,
                ...params,
              }
              break
            case '2':
              const imgList = this.currentPublishData.image
                ? JSON.parse(this.currentPublishData.image)
                : []
              let img = ''
              imgList.forEach((it) => {
                img += `<img src="${this.fileUrl}${it.id}">`
              })
              this.publishDetailData = {
                attachFile: '',
                indexImage: imgList.length ? imgList[0].id : '',
                content: img,
                textAuthor: this.userInfo.id,
                imageAuthor: this.userInfo.id,
                ...params,
              }
              break
            case '3':
              this.publishDetailData = {
                indexImage: '',
                videoFile: this.currentPublishData.video
                  ? JSON.parse(this.currentPublishData.video)[0].id
                  : '',
                videoAuthor: this.userInfo.id,
                ...params,
              }
              break
            default:
              break
          }
        }
      })
    },
    colunmChange(val) {
      if (val && val.id) {
        this.getPermission(val)
      }
    },
    cancel() {
      this.dialogVisible = false
    },
    searchList() {
      this.page.pageNo = 1
      this.getList()
    },
    reset() {
      this.searchData = this.$options.data().searchData
      this.searchList()
    },
    operateBtn(row, type) {
      this.showAddEditDialog = true
      this.operateType = false
      this.detailData = row
      switch (type) {
        case 'create':
          this.operateTitle = this.handelTitle('新增')
          break
        case 'update':
          this.operateTitle = this.handelTitle('编辑')
          break
        case 'read':
          this.operateType = true
          this.operateTitle = this.handelTitle('查看')
          break
        default:
          break
      }
    },
    handelTitle(type) {
      let title = ''
      switch (this.activeName) {
        case '1':
          title = `${type}文字素材`
          return title
        case '2':
          title = `${type}图片素材`
          return title
        case '3':
          title = `${type}视频素材`
          return title
        default:
          return ''
      }
    },
    async getList() {
      this.tableLoading = true
      const params = {
        deptId: this.searchData.departmentId, // String | 部门Id
        uploaderName: this.searchData.personnel, // String | 上传人
        name: this.searchData.name, // String | 素材名称
        status:
          this.searchData.status || this.searchData.status === 0 ? this.searchData.status : null, // Number | 发布状态：已发布-1，未发布-0
        startTime: this.searchData.timeRange ? this.searchData.timeRange[0] : '', // 开始时间
        endTime: this.searchData.timeRange ? this.searchData.timeRange[1] : '', // 结束时间
      }
      let res = null
      switch (this.activeName) {
        case '1':
          res = await materialApi.getTextMaterial(this.page.pageNo, this.page.pageSize, params)
          break
        case '2':
          res = await materialApi.getImageMaterial(this.page.pageNo, this.page.pageSize, params)
          break
        case '3':
          res = await materialApi.getVideoMaterial(this.page.pageNo, this.page.pageSize, params)
          break
        default:
          break
      }
      if (res && res.length && !res[0]) {
        this.tableData = res[1].items
        this.page.total = res[1].totalCount
      }
      this.tableLoading = false
    },
    // 删除
    deleteData(list) {
      if (!list.length) {
        this.$message.warning('请先勾选要删除的数据项')
        return
      }
      this.$confirm('是否确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const ids = list.map((it) => {
            return it.id
          })
          let res = null
          switch (this.activeName) {
            case '1':
              res = await materialApi.deleteTextMaterial({ ids })
              break
            case '2':
              res = await materialApi.deleteImageMaterial({ body: ids })
              break
            case '3':
              res = await materialApi.deleteVideoMaterial({ body: ids })
              break
            default:
              break
          }
          if (res && res.length && !res[0]) {
            this.$message.success('删除成功')
            this.getList()
          }
        })
        .catch(() => {})
    },
    // 前往发布
    toPublish(row) {
      this.dialogVisible = true
      this.currentPublishData = row
      this.colunmList = []
      this.searchDataList.forEach((element) => {
        let flag = true
        // 过滤类型
        if (element.type !== Number(this.activeName)) {
          flag = false
        }
        if (flag) {
          const item = _.cloneDeep(element)
          this.colunmList.push(item)
        }
      })
    },
    selectionChange(list) {
      this.selectionList = list
    },
    handleClick(tab, event) {
      this.getList()
    },
    closeAddEditDialog() {
      this.showAddEditDialog = false
    },
    async handleSaveSuccess() {
      this.openPublish = false
      const params = {
        id: this.currentPublishData.id, // String | id
        status: 1, // Number | 状态
      }
      let res = null
      switch (this.activeName) {
        case '1':
          res = await materialApi.updateTextMaterialStatus(params)
          break
        case '2':
          res = await materialApi.updateImageMaterialStatus(params)
          break
        case '3':
          res = await materialApi.updateVideoMaterialStatus(params)
          break
        default:
          break
      }
      if (res && res.length && !res[0]) {
        this.getList()
      }
    },
    treeNodeClick(val) {
      this.searchData.deptment = val.displayName
      this.searchData.departmentId = val.id
      this.$refs.treeSelectRef.blur()
    },
    // 获取部门树
    async getDeptTree() {
      const [err, res] = await organizationApi.getAllListDetails({
        filter: '',
        sorting: '',
      })
      if (!err) {
        this.treeData = res.items
      }
    },
    // 获取栏目树
    async columTree() {
      const [err, res] = await columApi.tree(0)
      if (!err && res) {
        this.columTreeData = res
        this.columTreeData.forEach((element) => {
          this.getSearchDataList(element)
        })
      }
    },
    // 递归获取所有树的节点
    getSearchDataList(item) {
      if (item != null) {
        this.searchDataList.push(item)
        item?.child?.forEach((element) => {
          this.getSearchDataList(element)
        })
      }
    },
    // 获取栏目权限
    async getPermission(data) {
      const [err, res] = await columnRightsApi.getColumnRight({
        columnId: data.id,
      })
      if (!err) {
        this.columnPermission = JSON.parse(res)
      }
    },
    // 获取用户详细信息
    async getUserDetail() {
      this.pageLoading = true
      const [err, res] = await eafProfileApi.getCurrentUserEafProfile()
      if (!err) {
        this.userInfo = res
      }
    },
  },
  async created() {
    await this.getUserDetail()
    this.getDeptTree()
    this.columTree()
    this.getList()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__content {
  line-height: 36px;
}
::v-deep .el-input--mini .el-input__icon {
  line-height: 28px;
}
.data-source-tree {
  &::-webkit-scrollbar {
    width: 6px;
  }
  ::v-deep .el-tree-node__content {
    height: 36px;
  }
}
</style>
<style lang="scss">
.data-source-select-tree {
  .el-select-dropdown__wrap {
    max-height: 100%;
  }
}
</style>
